export default __webpack_public_path__ + "media/plus/plus-history-516036ac.png";